// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"_3cZvXphHeQvJUvQMDGWeYf","signUpButton":"_2nq_azvXeJ0GCmTMws_bwU"};